module.exports = __webpack_public_path__ + "img/signs5.e82f7df5.jpg";